import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "chat-container" }
const _hoisted_2 = { class: "top-actions" }
const _hoisted_3 = { class: "left-actions" }
const _hoisted_4 = { class: "account-display" }
const _hoisted_5 = { class: "right-actions" }
const _hoisted_6 = { class: "main-content" }
const _hoisted_7 = { class: "left-panel" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  class: "no-data"
}
const _hoisted_10 = { class: "middle-panel" }
const _hoisted_11 = { class: "chat-list" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "chat-info" }
const _hoisted_14 = { class: "chat-name" }
const _hoisted_15 = { class: "chat-id" }
const _hoisted_16 = { class: "right-panel" }
const _hoisted_17 = {
  class: "message-container",
  ref: "messageContainer"
}
const _hoisted_18 = {
  key: 0,
  class: "message-content"
}
const _hoisted_19 = { class: "message-header" }
const _hoisted_20 = { class: "chat-name" }
const _hoisted_21 = { class: "chat-id" }
const _hoisted_22 = { class: "message-body" }
const _hoisted_23 = {
  key: 1,
  class: "no-chat-selected"
}
const _hoisted_24 = {
  key: 0,
  class: "private-chat-container"
}
const _hoisted_25 = {
  key: 1,
  class: "task-manager-container"
}
const _hoisted_26 = {
  key: 2,
  class: "agent-manager-container"
}
const _hoisted_27 = {
  key: 3,
  class: "agent-manager-container"
}

import { ref, onMounted,onUnmounted } from "vue";
import {
  PlusOutlined,
  SyncOutlined,
  MailOutlined,
  UploadOutlined,
  DeleteOutlined,
  ScheduleOutlined,
  EditOutlined,
  UserOutlined,
  ApiTwoTone,
} from "@ant-design/icons-vue";
import AddTelegramAccountModal from "./AddTelegramAccountModal.vue";
import AddFriendModal from "./AddFriendModal.vue";
import SendMessageModal from "./SendMessageModal.vue";
import { TelegramClient } from "@/websocket/Client";
import { message } from "ant-design-vue";
import ImportXlsx from "./ImportXlsx.vue";
import ImportXlsxID from "./ImportXlsxID.vue";
import DeleteAccountModal from "./DeleteAccountModal.vue";
import privatechat from "./privateChat/privatechat.vue"
import TaskManager from "./TaskManager.vue"; // 导入任务管理组件
import AgentManager from "./AgentManager.vue"; // 导入任务管理组件
import AgentBindManager from "./AgentBindManager.vue"; // 导入任务管理组件
import { useRouter } from "vue-router";
import { useStore } from 'vuex';
import FriendListModal from "./FriendListModal.vue";
interface AccountInfo {
  strAccount: string;
  strStatus?: string;
}

interface AccountListResponse {
  list: AccountInfo[];
}

interface ChatMessage {
  to: string;
  chatId: string;
  username: string;
  message: string;
}

declare global {
  interface Window {
    electron: {
      ipcRenderer: {
        on: (channel: string, func: (...args: any[]) => void) => void;
        send: (channel: string, ...args: any[]) => void;
      };
    };
  }
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ChatPage',
  setup(__props) {

const store = useStore();
const router = useRouter();
// 接口定义
const loading = ref(false);
const accounts = ref<AccountInfo[]>([]);
const currentAccount = ref<AccountInfo | null>(null);
const privateChatModalVisible = ref(false);
const addAccountModalVisible = ref(false);
const sendMessageModalVisible = ref(false);
const addFriendModalVisible = ref(false);
const friendListModalVisible = ref(false);
const importModalVisible = ref(false);
const importModalVisibleID = ref(false);
const deleteAccountModalVisible = ref(false);
const taskModalVisible = ref(false);
const agentModalVisible = ref(false);
const agentBindModalVisible = ref(false);
const chatList = ref<ChatMessage[]>([]);
const selectedChat = ref<ChatMessage | null>(null);

// 使用 Map 为每个账号存储其聊天列表
const accountChats = ref<Map<string, ChatMessage[]>>(new Map());

// 获取账号列表
const getAccountList = async () => {
  try {
    loading.value = true;
    const username = localStorage.getItem("username");
    if (!username) {
      throw new Error("未找到登录用户名");
    }

    const client = TelegramClient.getInstance();
    const response = await client.getAccountList(username);
    console.log("【DEBUG】获取到的账号列表响应:", response);

    // 检查是否有 list 属性
    if (response && response.list) {
      accounts.value = response.list.map((item: any) => ({
        strAccount: item.strAccount,
        strStatus: item.strStatus || "",
      }));

      console.log("【DEBUG】处理后的账号列表:", accounts.value);

      if (!currentAccount.value && accounts.value.length > 0) {
        currentAccount.value = accounts.value[0];
        console.log("【DEBUG】已选择默认账号:", currentAccount.value);
        store.state.user.name = currentAccount.value.strAccount;
      }

    }
  } catch (error) {
    console.error("获取账号列表失败:", error);
  } finally {
    loading.value = false;
  }
};

// 监听账号列表返回
onMounted(async () => {
  try {
    const client = TelegramClient.getInstance();
    // 确保只连接一次
    await client.connect();
    console.log("组件已挂载，开始获取账号列表");
    getAccountList();
  } catch (error) {
    console.error("初始化失败:", error);
  }
});

// 选择账号
const selectAccount = (account: AccountInfo) => {
  currentAccount.value = account;

};

// 按钮点击处理方法
const showAddAccountModal = () => {
  addAccountModalVisible.value = true;
};

// 显示聊天界面
const showChatModal = () => {
  if(currentAccount.value == null) return;
  console.log("showChatModal");
  privateChatModalVisible.value = true;
};
 

const showAddFriendModal = () => {
 
  addFriendModalVisible.value = true;

};

const showFriendListModal = () => {
 
 friendListModalVisible.value = true;

};


//绑定代理IP
const showBindAgentModal = () => {
  agentBindModalVisible.value = true;
};

const showSendMessageModal = () => {
  sendMessageModalVisible.value = true;
};

const showImportModal = () => {
  importModalVisible.value = true;
};


const showImportModalID = () => {
  importModalVisibleID.value = true;
};

const showDeleteAccountModal = () => {
  deleteAccountModalVisible.value = true;
};

// 显示任务模态框方法
const showTaskModal = () => {
  taskModalVisible.value = true;
};

//显示代理ip
const showAgentModal = () => {
  agentModalVisible.value = true;
};



// 统一的更新聊天数据的函数
const updateChatData = (newChats: ChatMessage | ChatMessage[]) => {
  if (!currentAccount.value) return;

  const chatsArray = Array.isArray(newChats) ? newChats : [newChats];
  
  // 更新每个聊天
  chatsArray.forEach(newChat => {
    const existingChatIndex = chatList.value.findIndex(
      chat => String(chat.chatId) === String(newChat.chatId)
    );

    if (existingChatIndex !== -1) {
      // 更新现有聊天
      chatList.value = chatList.value.map((chat, index) => {
        if (index === existingChatIndex) {
          return { 
            ...chat, 
            message: newChat.message,
            timestamp: newChat.timestamp 
          };
        }
        return chat;
      });
    } else {
      // 添加新聊天
      chatList.value = [...chatList.value, {
        ...newChat,
        chatId: String(newChat.chatId)
      }];
    }
  });

  // 更新 Map 中存储的聊天列表
  accountChats.value.set(currentAccount.value.strAccount, [...chatList.value]);

  // 如果当前选中的聊天在更新列表中，也更新它
  if (selectedChat.value) {
    const updatedChat = chatList.value.find(
      chat => String(chat.chatId) === String(selectedChat.value?.chatId)
    );
    if (updatedChat) {
      selectedChat.value = { ...updatedChat };
    }
  }
};

// 获取聊天数据
const handleGetChatData = async () => {
  if(true) return;
  try {
    if (!currentAccount.value) {
      message.error("请先选择一个账号");
      return;
    }
    const sesionId = localStorage.getItem("session");
    if (!sesionId) {
      throw new Error("未找到用户sesionId");
    }
    
    const client = TelegramClient.getInstance();
    const response = await client.getPrivateChatData(currentAccount.value, sesionId);
    console.log("获取到的私聊数据:", response);
    
    if (response) {
      updateChatData(response);
      message.success("获取聊天数据成功");
    }
  } catch (error) {
    console.error("获取聊天数据失败:", error);
    message.error("获取聊天数据失败");
  }
};

const handChatData = (newMessage)=>{

  console.log('收到新消息:', newMessage);
    
    // 只处理当前选中账号的消息
    if (currentAccount.value && newMessage.username === currentAccount.value.strAccount) {
      updateChatData(newMessage);
    }

}  

const handOperationResult = (newMessage)=>{

   console.log('handOperationResult:', newMessage);
   var detail = newMessage.detail
   if(detail.code == 20000)//你在其他地方登陆
   {
       message.warning('您的账号在其他地方登陆');
       router.push("/login");
   } 

}


// WebSocket 消息监听
onMounted(() => {
  const client = TelegramClient.getInstance();
  client.addChatUpdateListener(handChatData);
  client.addOperationResultListener(handOperationResult);
  console.log("chatPage onMounted");
});

onUnmounted(() => {

  const client = TelegramClient.getInstance();
  client.removeChatUpdateListener(handChatData);
  client.removeOperationResultListener(handOperationResult);
 
});


// 修改账号选择处理函数
const handleAccountSelect = (account: AccountInfo) => {
  currentAccount.value = account;
  // 从 Map 中获取该账号的聊天列表，如果没有则显示空数组
  chatList.value = accountChats.value.get(account.strAccount) || [];
  //handleGetChatData(); // 获取新的聊天数据
  store.state.user.name = currentAccount.value.strAccount;
  console.log("handleAccountSelect");

};

// 模态框回调处理方法
const handleAddAccountSuccess = () => {
  // 添加账号成功后重新获取账号列表
  getAccountList();
};

const handleSendMessageSuccess = () => {
  console.log("发送消息成功");
};

// 处理删除账号成功
const handleDeleteAccountSuccess = async () => {
  deleteAccountModalVisible.value = false;
  await getAccountList();
  message.success("删除账号成功");
};

const selectChat = (chat: ChatMessage) => {
  selectedChat.value = chat;
  console.log('已选择聊天:', chat);
};

// 声明 window 上的 electron 属性

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: showAddAccountModal
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(PlusOutlined)),
            _cache[11] || (_cache[11] = _createTextVNode("添加TG账号 "))
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          type: "primary",
          click: "",
          onClick: showBindAgentModal
        }, {
          default: _withCtx(() => _cache[12] || (_cache[12] = [
            _createTextVNode(" 绑定代理IP ")
          ])),
          _: 1
        }),
        _createVNode(_component_a_button, {
          type: "primary",
          danger: "",
          onClick: showDeleteAccountModal
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(DeleteOutlined)),
            _cache[13] || (_cache[13] = _createTextVNode("删除TG账号 "))
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: showChatModal
        }, {
          default: _withCtx(() => _cache[14] || (_cache[14] = [
            _createTextVNode("进入私聊")
          ])),
          _: 1
        }),
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: showAddFriendModal
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(PlusOutlined)),
            _cache[15] || (_cache[15] = _createTextVNode("加好友 "))
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: showFriendListModal
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(UserOutlined)),
            _cache[16] || (_cache[16] = _createTextVNode("好友列表 "))
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, _toDisplayString(currentAccount.value?.strAccount || ""), 1),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: showAgentModal
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ApiTwoTone)),
            _cache[17] || (_cache[17] = _createTextVNode("代理IP "))
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: handleGetChatData
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(SyncOutlined)),
            _cache[18] || (_cache[18] = _createTextVNode("获取聊天 "))
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: showSendMessageModal
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(MailOutlined)),
            _cache[19] || (_cache[19] = _createTextVNode("群发消息 "))
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: showImportModal
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(UploadOutlined)),
            _cache[20] || (_cache[20] = _createTextVNode("导入私聊账号 "))
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: showImportModalID
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(UploadOutlined)),
            _cache[21] || (_cache[21] = _createTextVNode("导入私聊数字ID "))
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: showTaskModal
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ScheduleOutlined)),
            _cache[22] || (_cache[22] = _createTextVNode("任务 "))
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_a_spin, { spinning: loading.value }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accounts.value, (account) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["account-item", {
              active: currentAccount.value?.strAccount === account.strAccount,
            }]),
                key: account.strAccount,
                onClick: ($event: any) => (handleAccountSelect(account))
              }, [
                _createVNode(_component_a_avatar, { size: 40 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(account.strAccount.charAt(1)), 1)
                  ]),
                  _: 2
                }, 1024),
                _createElementVNode("div", null, _toDisplayString(account.strAccount), 1)
              ], 10, _hoisted_8))
            }), 128)),
            (!loading.value && accounts.value.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, " 暂无账号数据 "))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["spinning"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _cache[23] || (_cache[23] = _createElementVNode("div", { class: "panel-title" }, "接收私聊名单", -1)),
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chatList.value, (chat) => {
            return (_openBlock(), _createElementBlock("div", {
              key: chat.chatId,
              class: _normalizeClass(["chat-item", { active: selectedChat.value?.chatId === chat.chatId }]),
              onClick: ($event: any) => (selectChat(chat))
            }, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, _toDisplayString(chat.username), 1),
                _createElementVNode("span", _hoisted_15, "(" + _toDisplayString(chat.chatId) + ")", 1)
              ])
            ], 10, _hoisted_12))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          (selectedChat.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("span", _hoisted_20, _toDisplayString(selectedChat.value.username), 1),
                  _createElementVNode("span", _hoisted_21, "(" + _toDisplayString(selectedChat.value.chatId) + ")", 1)
                ]),
                _createElementVNode("div", _hoisted_22, _toDisplayString(selectedChat.value.message), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_23, " 请选择一个聊天 "))
        ], 512),
        _cache[24] || (_cache[24] = _createElementVNode("div", { class: "input-area" }, null, -1))
      ])
    ]),
    _createVNode(AddTelegramAccountModal, {
      visible: addAccountModalVisible.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((addAccountModalVisible).value = $event)),
      onSuccess: handleAddAccountSuccess
    }, null, 8, ["visible"]),
    _createVNode(SendMessageModal, {
      visible: sendMessageModalVisible.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((sendMessageModalVisible).value = $event)),
      accounts: accounts.value,
      onSuccess: handleSendMessageSuccess
    }, null, 8, ["visible", "accounts"]),
    _createVNode(AddFriendModal, {
      visible: addFriendModalVisible.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((addFriendModalVisible).value = $event))
    }, null, 8, ["visible"]),
    _createVNode(FriendListModal, {
      visible: friendListModalVisible.value,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((friendListModalVisible).value = $event))
    }, null, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      visible: importModalVisible.value,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((importModalVisible).value = $event)),
      title: "导入私聊账号",
      footer: null,
      width: "800px"
    }, {
      default: _withCtx(() => [
        _createVNode(ImportXlsx)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      visible: importModalVisibleID.value,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((importModalVisibleID).value = $event)),
      title: "导入私聊数字ID",
      footer: null,
      width: "800px"
    }, {
      default: _withCtx(() => [
        _createVNode(ImportXlsxID)
      ]),
      _: 1
    }, 8, ["visible"]),
    (privateChatModalVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createVNode(privatechat, {
            visible: privateChatModalVisible.value,
            "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((privateChatModalVisible).value = $event))
          }, null, 8, ["visible"])
        ]))
      : _createCommentVNode("", true),
    (taskModalVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _createVNode(TaskManager, {
            visible: taskModalVisible.value,
            "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((taskModalVisible).value = $event))
          }, null, 8, ["visible"])
        ]))
      : _createCommentVNode("", true),
    (agentModalVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createVNode(AgentManager, {
            visible: agentModalVisible.value,
            "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((agentModalVisible).value = $event))
          }, null, 8, ["visible"])
        ]))
      : _createCommentVNode("", true),
    (agentBindModalVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createVNode(AgentBindManager, {
            visible: agentBindModalVisible.value,
            "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((agentBindModalVisible).value = $event))
          }, null, 8, ["visible"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(DeleteAccountModal, {
      visible: deleteAccountModalVisible.value,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((deleteAccountModalVisible).value = $event)),
      onSuccess: handleDeleteAccountSuccess
    }, null, 8, ["visible"])
  ]))
}
}

})